import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { ThemeProvider } from "./context/ThemeContext";
import Home from "./pages/Home"; // Corrected import path
import About from "./pages/About";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Music from "./pages/Music";
import Listen from "./pages/Listen";
import SongsAdmin from "./pages/SongsAdmin";
import Tutorial from "./pages/Tutorial";
import MagicTool from "./pages/MagicTool";
import Moments from "./pages/Moments";
import Webinar from "./pages/Webinar";
import AdminMagicData from "./pages/AdminMagicData";
import Survey from "./pages/Survey";
import Special from "./pages/Special";
import ScrollToTop from "./components/ScrollToTop";

const App = () => {
  // Scroll to #faq if hash is present and element exists
  useEffect(() => {
    if (window.location.hash === "#faq") {
      // Use setTimeout to ensure DOM is updated after navigation
      setTimeout(() => {
        const faqSection = document.getElementById("faq");
        if (faqSection) {
          faqSection.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }, 100);
    }
  }, [window.location.hash]);

  return (
    <HelmetProvider>
      <ThemeProvider>
        <Router>
          <ScrollToTop />
          <React.Suspense fallback={<div>Loading...</div>}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/music" element={<Music />} />
              <Route path="/listen" element={<Listen />} />
              <Route path="/admin" element={<SongsAdmin />} />
              <Route path="/tutorial" element={<Tutorial />} />
              <Route path="/magictool" element={<MagicTool />} />
              <Route path="/moments" element={<Moments />} />
              <Route path="/zoom" element={<Webinar />} />
              <Route path="/webinar" element={<Webinar />} />
              <Route path="/admin-magic-data" element={<AdminMagicData />} />
              <Route path="/survey" element={<Survey />} />
              <Route path="/special" element={<Special />} />
            </Routes>
          </React.Suspense>
        </Router>
      </ThemeProvider>
    </HelmetProvider>
  );
};

export default App;
